{{#unless legacy}}
  {{#if alertIcon}}
    <div class="Alert-iconGutter">{{icon alertIcon}}</div>
  {{/if}}

  <div class="Alert-content">
    {{#if title}}
      <h3>
        {{#if allowHtmlInTitle}}
          {{{title}}}
        {{else}}
          {{title}}
        {{/if}}
      </h3>
    {{/if}}

    {{#if details}}
      <button type="button" class="btn btn-tertiary btn-details" data-action="toggleDetails">
        {{icon "caret-right" "Show" className="caret-right-wrapper"}}
        {{icon "caret-down" "Hide" className="caret-down-wrapper"}}
        <span class="btn-details-text">
          {{#if message}}
            {{#if allowHtmlInMessage}}
              {{{message}}}
            {{else}}
              {{message}}
            {{/if}}
          {{else}}
            {{locale "details"}}
          {{/if}}
        </span>
      </button>

        <div class="glu-alert-details-region" data-region="alert-details" data-action="details"></div>
    {{else}}
      <p>{{#if allowHtmlInMessage}}{{{message}}}{{else}}{{message}}{{/if}}</p>
    {{/if}}
  </div>

  {{#if canDismiss}}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">{{icon theme.closeIcon}}</button>
  {{/if}}
{{else}}
  {{#if canDismiss}}
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">{{icon "close"}}</button>
  {{/if}}

  {{#if details}}
    <button type="button" class="btn btn-tertiary btn-details" data-action="toggleDetails">
      {{icon "caret-right" "Show" className="caret-right-wrapper"}}
      {{icon "caret-down" "Hide" className="caret-down-wrapper"}}
      <span class="btn-details-text">{{locale "details"}}</span>
    </button>
  {{/if}}

  {{#if alertIcon}}{{icon alertIcon}}{{/if}}

  {{#if title}}<h3>{{#if allowHtmlInTitle}}{{{title}}}{{else}}{{title}}{{/if}}</h3>{{/if}}

  <p>{{#if allowHtmlInMessage}}{{{message}}}{{else}}{{message}}{{/if}}</p>

  {{#if details}}
    <div class="glu-alert-details-region" data-region="alert-details" data-action="details"></div>
  {{/if}}
{{/unless}}
